<template>
  <div class="evolution-system">
    <div style="width: 150%;height: 200px;background-color: black"></div>

    <div class="evo-first-show">
      <p class="evo-first-show-text">{{ $t('series.evolution_system')}}</p>
      <p class="evo-first-show-text">{{ $t('series.evolution_try')}}</p>
    </div>
    <div class="evo-text-section">
      <p class="system-info" ref="systemInfo">
        {{ $t('series.evolution_desc1')}}<br>
        {{ $t('series.evolution_desc2')}}<br>
        {{ $t('series.evolution_desc3')}}
      </p>
      <h2 class="system-title" ref="systemTitle">EVOLUTION Cutting System</h2>
    </div>
    <!-- 界面截图 -->
    <div class="img-section">
      <img
          src="../../static/series/EvolutionSystem.png"
          class="system-img"
          ref="systemImg"
      >
    </div>
    <div class="evolution-bottom-content">
      <p class="system-title2" ref="systemTitle">EVOLUTION Cutting System</p>
      <p class="software-info" ref="softwareInfo">{{ $t('series.evolution_desc4')}}</p>
      <div style="height: 30px"></div>
      <!-- zh style -->
      <p v-if="this.$i18n.locale === 'zh'"  class="system-desc" ref="systemDesc">
        {{ $t('series.evolution_desc5')}}<br>
        {{ $t('series.evolution_desc6')}}<br>
        {{ $t('series.evolution_desc7')}}
      </p>
      <!-- en style -->
      <p v-else class="system-desc" ref="systemDesc">
        {{ $t('series.evolution_desc5')}}
        {{ $t('series.evolution_desc6')}}<br>
        {{ $t('series.evolution_desc7')}}
      </p>
    </div>
    <!-- 上下间距 -->
    <div style="width: 150%;height: 200px;background-color: black"></div>
  </div>
</template>

<script>
export default {
  name: 'EvolutionSystem',
  data() {
    return {};
  },
  mounted() {
    // 使用$nextTick确保DOM渲染完成
    this.$nextTick(() => {
      // 隐藏字体
      this.$gsap.set('.evo-text-section', {
        opacity: 0,
        y: 200
      })

      this.$gsap.set('.evo-first-show', {
        y: 400
      })

      // 创建动画时间线
      const tl = this.$gsap.timeline({
        // 滚动触发配置
        scrollTrigger: {
          trigger: '.evo-text-section', // 触发元素
          start: 'top 100%', // 开始位置：元素顶部到达视口80%处
          end: 'bottom 20%', // 结束位置
          // scrub: 1, // 不随滚动位置更新动画
          once: false, // 只触发一次
          toggleActions: 'play none none none'
        }
      });

      tl.to('.evo-first-show', {
        y: 330,
        duration: 1,
        ease: 'power2.in'
      },0.5)

      tl.to('.evo-first-show', {
        y: 0,
        opacity: 0,
        duration: 1,
        ease: 'power2.in'
      }, 2)

      tl.to('.img-section', {
        y: -100,
        duration: 1,
        ease: 'power2.in'
      }, 2)

      //
      tl.to('.evo-text-section', {
        opacity: 1,
        duration: 1,
        y: -100,
        ease: 'power2.in'
      }, 2.3)

      const tl2 = this.$gsap.timeline({
        // 滚动触发配置
        scrollTrigger: {
          trigger: '.evolution-bottom-content', // 触发元素
          start: 'top 100%', // 开始位置：元素顶部到达视口80%处
          end: 'bottom 20%', // 结束位置
          // scrub: 1, // 不随滚动位置更新动画
          once: true, // 只触发一次
          toggleActions: 'play none none none',
          markers: false,
        }
      });

      tl2.to('.evolution-bottom-content', {
        duration: 0.8,
        opacity: 1,
        y: -100,
        ease: 'power2.in'
      }, 0.3)

    });
  }
};
</script>

<style lang="less" scoped>
// 页面整体容器，占页面宽度80%
.evolution-system {
  width: 100%;
  margin: 0 auto;
  padding: 40px 20px;
  box-sizing: border-box;
  background-color: #000;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  //margin-top: 200px;
  overflow: hidden; // 防止动画时内容溢出
}

.evo-first-show {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.evo-first-show p {
  margin-top: 0;
  font-size: 3.5em;
  margin-bottom: 0;
}

.evo-first-show p:nth-of-type(1) {
  color: white;
}

.evo-first-show p:nth-of-type(2) {
  background: linear-gradient(90deg, #cc40bc, #e08bd7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

// 文字区域样式
.evo-text-section {
  margin-bottom: 30px;
  text-align: center;
  line-height: 1.6;
  width: 100%;

  p {
    max-width: 100%;
  }
}

.system-info {
  font-size: var(--font-size-lg2);
  text-align: left;
  margin-left: 30vw;
}

.system-title {
  font-size: var(--font-size-xl);
  color: #48a6e6;
  margin: 10px 0;
  /* 文字渐变核心样式 - 从亮到暗 */
  background: linear-gradient(90deg, #89d6f5, #0a6b91);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  margin-left: 30vw;
}

.evolution-bottom-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
}

.system-title2 {
  font-size: var(--font-size-xl);
  color: #48a6e6;
  /* 文字渐变核心样式 - 从亮到暗 */
  background: linear-gradient(90deg, #89d6f5, #0a6b91);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0;
}

.software-info {
  font-size: 1.5em;
  color: #ccc;
  margin: 0 0 20px;
}

.system-desc {
  font-size: 2.0em;
  margin: 0;
}

// 图片容器，占满父容器宽度
.img-section {
  width: 102.5%;
  display: flex;
  justify-content: center;
  z-index: 2;
}

// 图片样式，宽度100%，高度自适应
.system-img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

// 小屏幕适配，居中对齐
@media (max-width: 768px) {
  .system-title {
    font-size: 1.5em;
  }

  .software-info {
    font-size: 1em;
  }

  .system-desc {
    font-size: 1em;
  }

  .system-info {
    font-size: 1em;
  }
}
</style>
